import type { SecureStore } from '../platform/PlatformBridge.js';
import type { TokenStore } from './TokenStore.js';

/**
 * Desktop TokenStore — backed by OS-secure storage via PlatformBridge.
 *
 * Step 6.3 of Forge_iDAS_Desktop_Developer_Instructions.docx:
 *   "Never store auth tokens in plain localStorage on desktop."
 *
 * The token is persisted under the well-known key `forgedas.auth.token` so it
 * round-trips across app restarts. Reads are async (safeStorage decrypts on
 * the main process side); createApiClient already awaits the token, so this
 * works without any change to the request interceptor.
 */

const TOKEN_KEY = 'forgedas.auth.token';

export class DesktopTokenStore implements TokenStore {
  constructor(private readonly secureStore: SecureStore) {}

  getToken(): Promise<string | null> {
    return this.secureStore.get(TOKEN_KEY);
  }

  async setToken(token: string): Promise<void> {
    await this.secureStore.set(TOKEN_KEY, token);
  }

  async clearToken(): Promise<void> {
    await this.secureStore.delete(TOKEN_KEY);
  }
}
